import React from 'react';
import { Register } from '../factory';
import { PickerView, Modal } from 'antd-mobile';
import { getLabelByValue, getProvinceList, getRegionSubInfo } from '../../../service/AddressService';

const titleList = {
    province: '选择省份',
    city: '选择城市',
    area: '选择城镇/区',
};
const defaultValue = {
    provinceCode: '',
    provinceName: '',
    cityCode: '',
    cityName: '',
    areaCode: '',
    areaName: '',
};

@Register({ name: 'dy-pcd' })
class DyPcd extends React.Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            provinceList: [],
            cityList: [],
            areaList: [],
            provinceVisit: false,
            cityVisit: false,
            areaVisit: false,

            ...defaultValue,
        };
    }
    oldValue: any[] = [];

    async componentWillMount() {
        let provinceList = await getProvinceList();
        this.setState({
            provinceList: provinceList,
        });
    }
    handleCancel = key => {
        const { value } = this.props;
        let newValue = value ? value : defaultValue;
        this.setState(
            {
                ...newValue,
            },
            () => {
                this.props.onChange(value ? value : null);
                this.toggleModalVisit(`${key}Visit`, false);
            }
        );
    };
    toggleModalVisit = (key, value) => {
        this.setState({
            [key]: value,
        });
    };
    handlePickChange = (key, val) => {
        this.setState({
            [`${key}Code`]: val[0],
            [`${key}Name`]: getLabelByValue(this.state[`${key}List`], val[0]),
        });
    };
    handleProvinceSure = async () => {
        this.toggleModalVisit('provinceVisit', false);
        const { provinceCode } = this.state;
        let cityList = await getRegionSubInfo('province', provinceCode);
        this.setState({
            cityList,
            cityVisit: true,
        });
    };
    handleCitySure = async () => {
        this.toggleModalVisit('cityVisit', false);
        const { cityCode } = this.state;
        let areaList = await getRegionSubInfo('city', cityCode);
        this.setState({
            areaList,
            areaVisit: true,
        });
    };
    handleAreaSure = async () => {
        this.toggleModalVisit('areaVisit', false);
        const { provinceCode, provinceName, cityCode, cityName, areaCode, areaName } = this.state;
        this.props.onChange({
            provinceCode,
            provinceName,
            cityCode,
            cityName,
            areaCode,
            areaName,
        });
    };

    render() {
        const {
            provinceList,
            cityList,
            areaList,
            provinceVisit,
            cityVisit,
            areaVisit,
            provinceCode,
            provinceName,
            cityCode,
            cityName,
            areaCode,
            areaName,
        } = this.state;
        let { className, name, value } = this.props;

        return (
            <div className={`dy-fm-item ${className ? className : ''}`}>
                <div
                    className={`dy-fm-item-pick-view ${value && value.provinceName ? 'edited' : ''}`}
                    onClick={() => this.toggleModalVisit('provinceVisit', true)}
                >
                    {value && value.provinceName ? value.provinceName : '请选择省'}
                    {value && value.cityName ? `/${value.cityName}` : '/请选择市'}
                    {value && value.areaName ? `/${value.areaName}` : '/请选择区'}
                </div>

                <Modal popup visible={provinceVisit} onClose={() => this.handleCancel('province')} animationType="slide-up">
                    <div className="am-picker-popup-header">
                        <div className="am-picker-popup-item am-picker-popup-header-left" onClick={() => this.handleCancel('province')}>
                            取消
                        </div>
                        <div className="am-picker-popup-item am-picker-popup-title">{titleList['province']}</div>
                        <div className="am-picker-popup-item am-picker-popup-header-right" onClick={this.handleProvinceSure}>
                            确定
                        </div>
                    </div>
                    <PickerView
                        data={provinceList}
                        value={[provinceCode]}
                        cols={1}
                        onChange={val => this.handlePickChange('province', val)}
                    />
                </Modal>
                <Modal popup visible={cityVisit} onClose={() => this.handleCancel('city')} animationType="slide-up">
                    <div className="am-picker-popup-header">
                        <div className="am-picker-popup-item am-picker-popup-header-left" onClick={() => this.handleCancel('city')}>
                            取消
                        </div>
                        <div className="am-picker-popup-item am-picker-popup-title">{titleList['city']}</div>
                        <div className="am-picker-popup-item am-picker-popup-header-right" onClick={this.handleCitySure}>
                            确定
                        </div>
                    </div>
                    <PickerView data={cityList} value={[cityCode]} cols={1} onChange={val => this.handlePickChange('city', val)} />
                </Modal>
                <Modal popup visible={areaVisit} onClose={() => this.handleCancel('area')} animationType="slide-up">
                    <div className="am-picker-popup-header">
                        <div className="am-picker-popup-item am-picker-popup-header-left" onClick={() => this.handleCancel('area')}>
                            取消
                        </div>
                        <div className="am-picker-popup-item am-picker-popup-title">{titleList['area']}</div>
                        <div className="am-picker-popup-item am-picker-popup-header-right" onClick={this.handleAreaSure}>
                            确定
                        </div>
                    </div>
                    <PickerView data={areaList} value={[areaCode]} cols={1} onChange={val => this.handlePickChange('area', val)} />
                </Modal>
            </div>
        );
    }
}

export default DyPcd;
